import axios from "axios";

import { useSessionStore } from "@/store/sessionStore/sessionStore";

const chatAxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_CHAT_API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

chatAxiosInstance.interceptors.request.use((config) => {
  const { userId, userName, userType } = useSessionStore.getState();
  if (userId) {
    config.headers["x-user-id"] = userId;
  }
  if (userName) {
    config.headers["x-user-name"] = userName;
  }
  if (userType) {
    config.headers["x-user-type"] = userType;
  }
  return config;
});

export default chatAxiosInstance;
